export const WISHLIST_CREATE_REQUEST = "WISHLIST_CREATE_REQUEST";
export const WISHLIST_CREATE_SUCCESS = "WISHLIST_CREATE_SUCCESS";
export const WISHLIST_CREATE_FAIL = "WISHLIST_CREATE_FAIL";
export const WISHLIST_CREATE_RESET = "WISHLIST_CREATE_RESET";

export const WISHLIST_UPDATE_REQUEST = "WISHLIST_CREATE_REQUEST";
export const WISHLIST_UPDATE_SUCCESS = "WISHLIST_CREATE_SUCCESS";
export const WISHLIST_UPDATE_FAIL = "WISHLIST_CREATE_FAIL";

export const WISHLIST_DETAILS_REQUEST = "WISHLIST_DETAILS_REQUEST";
export const WISHLIST_DETAILS_SUCCESS = "WISHLIST_DETAILS_SUCCESS";
export const WISHLIST_DETAILS_FAIL = "WISHLIST_DETAILS_FAIL";

export const FIND_WISHLIST_DETAILS_REQUEST = "FIND_WISHLIST_DETAILS_REQUEST";
export const FIND_WISHLIST_DETAILS_SUCCESS = "FIND_WISHLIST_DETAILS_SUCCESS";
export const FIND_WISHLIST_DETAILS_FAIL = "FIND_WISHLIST_DETAILS_FAIL";

export const WISHLIST_DELETE_REQUEST = "WISHLIST_DELETE_REQUEST";
export const WISHLIST_DELETE_SUCCESS = "WISHLIST_DELETE_SUCCESS";
export const WISHLIST_DELETE_FAIL = "WISHLIST_DELETE_FAIL";
